import { Space } from 'antd';
import React from 'react';

import useCancelationAdyen from 'src/features/clients/hooks/useCancelationAdyen';
import { useSubscriptionsAdyenByEmail } from 'src/features/clients/hooks/useSubscriptionsAdyen';
import useSubscriptionsHotmart from 'src/features/clients/hooks/useSubscriptionsHotmart';
import useSubscriptionsPagarMe from 'src/features/clients/hooks/useSubscriptionsPagarMe';
import useTransactionsAdyen from 'src/features/clients/hooks/useTransactionsAdyen';
import useTransactionsHotmart from 'src/features/clients/hooks/useTransactionsHotmart';
import useTransactionsItunes from 'src/features/clients/hooks/useTransactionsItunes';
import useTransactionsPagarMe from 'src/features/clients/hooks/useTransactionsPagarMe';
import { CustomerLegacyTransactionsSection } from 'src/features/clients/screens/client-details-screen/client-details/table-components/CustomerLegacyTransactionsSection';
import { ClientType } from 'src/features/clients/types/clientTypes';

import { Customer } from '../../types/customer';

interface CustomerFinancialSummaryTabProps {
  customer: Customer;
}

export const CustomerFinancialSummaryTab: React.FC<
  CustomerFinancialSummaryTabProps
> = ({ customer }) => {
  const subscriptionsPagarMe = useSubscriptionsPagarMe(customer.email);
  const transactionsPagarMe = useTransactionsPagarMe(customer.email);
  const subscriptionsHotmart = useSubscriptionsHotmart(customer.email);
  const transactionsHotmart = useTransactionsHotmart(customer.email);
  const subscriptionsAdyen = useSubscriptionsAdyenByEmail(customer.email);
  const transactionsAdyen = useTransactionsAdyen(customer.email);
  const transactionsAdyenCancelation = useCancelationAdyen(customer.email);
  const transactionsItunes = useTransactionsItunes(customer.email);

  const legacyCustomer: ClientType = {
    ...customer,
    hasSon: String(customer.hasSon),
  };

  return (
    <Space
      direction='vertical'
      size='large'
      style={{ display: 'flex', marginTop: 24 }}
    >
      <CustomerLegacyTransactionsSection
        dados={legacyCustomer}
        subscriptionsPagarme={subscriptionsPagarMe.data?.subscriptions}
        transactionsPagarme={transactionsPagarMe.data?.transactions || []}
        assignHotmart={subscriptionsHotmart.data}
        transactionsHotmart={transactionsHotmart.data}
        assignAdyen={subscriptionsAdyen.data}
        transactionsAdyen={transactionsAdyen.data?.transactions}
        refundAdyen={transactionsAdyen.data?.refund}
        transactionsCancelation={transactionsAdyenCancelation.data?.transactions}
        transactionsItunes={transactionsItunes.data?.transactions}
      />
    </Space>
  );
};
